export default __webpack_public_path__ + "media/error-red-cross-circle-o.3cd54454.svg";